import { STATUS_DISPLAY_MAP, SERVICE_TYPE_DISPLAY_MAP, STATUS_COLOR_MAP } from '../config/jobConstants';
import { isJobOverdue, isJobDueToday } from '../utils/jobHelpers';
import { formatDuration } from '../../../utils/formatDuration';

// Format job data for display
export const formatJobForDisplay = (job) => {
  return {
    ...job,
    statusDisplay: formatStatus(job.status),
    serviceTypeDisplay: formatServiceType(job.service_type),
    scheduledDateDisplay: job.scheduled_date ? new Date(job.scheduled_date).toLocaleDateString() : 'Not scheduled',
    scheduledTimeDisplay: job.scheduled_date ? new Date(job.scheduled_date).toLocaleTimeString() : '',
    createdAtDisplay: job.created_at ? new Date(job.created_at).toLocaleDateString() : 'Unknown',
    priceDisplay: job.price ? `$${parseFloat(job.price).toFixed(2)}` : 'Not set',
    durationDisplay: job.estimated_duration ? formatDuration(job.estimated_duration) : 'Not set',
    actualDurationDisplay: job.actual_duration ? formatDuration(job.actual_duration) : 'Not recorded',
    isOverdue: isJobOverdue(job),
    isDueToday: isJobDueToday(job),
    customerDisplay: job.customer_name || 'Unknown Customer',
    technicianDisplay: job.technician_name || 'Unassigned'
  };
};

// Format status for display
export const formatStatus = (status) => {
  return STATUS_DISPLAY_MAP[status] || status;
};

// Format service type for display
export const formatServiceType = (serviceType) => {
  return SERVICE_TYPE_DISPLAY_MAP[serviceType] || serviceType;
};

// Get status color for UI
export const getStatusColor = (status) => {
  return STATUS_COLOR_MAP[status] || 'bg-gray-100 text-gray-800';
};